class EmployeeFront {
  constructor({
    employeeId = null,
    firstName = null,
    lastName = null,
    remoteId = null,
    reportsTo = null,
    startDate = null,
    endDate = null,
    status = null,
    shiftOverrideId = null,
    accessGroupId = null,
    department = {
      id: null,
      name: null,
      shiftId: null,
      hiddenId: null,
      hiddenName: null,
      hiddenShiftId: null,
    },
    isnew = false,
  }) {
    this.employeeId = employeeId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.remoteId = remoteId;
    this.reportsTo = reportsTo;
    this.startDate = new Date(Date.parse(startDate));
    this.endDate = new Date(Date.parse(endDate));
    this.status = status;
    this.shiftOverrideId = shiftOverrideId;
    this.accessGroupId = accessGroupId;
    this.department = department;
    this.isnew = isnew;
  }

  updateDepartment(departmentId, name, shiftId) {
    this.department = {
      id: departmentId,
      name: name,
      shiftId: shiftId,
    };
  }
}

class EmployeeBack {
  constructor({
    employeeId = null,
    firstName = null,
    lastName = null,
    accessGroupId = null,
    remoteId = null,
    reportsTo = null,
    startDate = null,
    endDate = null,
    status = null,
    shiftOverrideId = null,
    department = { id: null },
  }) {
    this.employeeId = employeeId;
    this.firstName = firstName;
    this.accessGroupId = accessGroupId;
    this.lastName = lastName;
    this.remoteId = remoteId;
    this.reportsTo = reportsTo;
    this.startDate = startDate;
    this.endDate = endDate;
    this.shiftOverrideId = shiftOverrideId;
    this.status = status ? true : false;
    this.departmentId = department.id;
  }
}

export { EmployeeFront, EmployeeBack };

// tata pravi igricu
// trov bol
